var map = {
	"./Form": "./app/javascript/components/Form.tsx",
	"./Form.tsx": "./app/javascript/components/Form.tsx",
	"./VimeoForm": "./app/javascript/components/VimeoForm.tsx",
	"./VimeoForm.tsx": "./app/javascript/components/VimeoForm.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/components sync recursive ^\\.\\/.*$";